
import React from "react";
import { formatDate, formatTime } from "@/utils/reportFormatters";
import { Tag } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface TeachingInfoProps {
  teachingDate: string;
  teachingTimeSlot: string;
  teacherDisplay: string;
  subject: string;
  content?: string;
  isOtherSubject?: boolean;
}

export const TeachingInfo: React.FC<TeachingInfoProps> = ({
  teachingDate,
  teachingTimeSlot,
  teacherDisplay,
  subject,
  content,
  isOtherSubject
}) => {
  return (
    <>
      <td>
        {formatDate(teachingDate)}{" "}
        <span className="text-xs text-muted-foreground">
          ({formatTime(teachingTimeSlot)})
        </span>
      </td>
      <td>{teacherDisplay}</td>
      <td>
        <div className="flex items-center gap-1">
          {subject}
          {isOtherSubject && (
            <Badge variant="outline" className="ml-1 flex items-center gap-1 border-amber-400 text-amber-600">
              <Tag className="h-3 w-3" />
              <span className="text-xs">หัวข้ออื่นๆ</span>
            </Badge>
          )}
        </div>
      </td>
      <td>{content || "-"}</td>
    </>
  );
};
